import {initCartPage} from "./init-cart-page";
import {initPage} from "./init-page";

window.addEventListener(`load`, () => {
  initPage();
  initCartPage(shopInfoData);
});
